import React, { useRef, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import "./editModalForNegotiation.scss"
import NegotiationFormComponent from "./negotiationFormComponent";
import { FormikProps } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../../../redux/Reducer";
import { UPDATE_DETAILED_NEGOTIATION_OVERVIEW } from "../../../../../redux/Action/actionTypes";

interface ModalComponentProps {
    isOpen: boolean;
    toggle: () => void;
    isEditStatus: string;
    id: string;
    contractStatus: string;
}

const EditModalForNegotiation = ({ isOpen, toggle, isEditStatus, id, contractStatus }: ModalComponentProps) => {
    const formikRef = useRef<FormikProps<any>>(null);

    const isFormUpdate = useSelector(
        (state: RootState) => state.basicDetails.formState
    );

    const basicDetailsData = useSelector(
        (state: RootState) => state.basicDetails.basicDetailsData
        //(state: RootState) => state.dashboardData?.detailedOverviewData?.basicDetails
    );

    const othersData = useSelector(
        (state: RootState) => state.dashboardData?.detailedOverviewData?.others
    );

    const powerPositionDetails = useSelector(
        (state: RootState) => state.powerPosition
        // (state: RootState) => state.dashboardData?.detailedOverviewData?.powerPosition
    );
    const TargetValueData = useSelector(
        (state: RootState) => state.TargetValue.TargetValueData
        // (state: RootState) => state.dashboardData?.detailedOverviewData?.targetValue
    );
    const salesRepClassificationData = useSelector(
        (state: RootState) => state.salesRepClassification
        // (state: RootState) => state.dashboardData?.detailedOverviewData?.salesRepClassification
    );

    const [isNextDisabled, setIsNextDisabled] = useState<boolean>(true);

    const PlanNegotiationActions = useSelector((state: RootState) => state.dashboardData?.detailedOverviewData?.planNegotiationActions?.negotiationRoundsDetails)

    const dispatch = useDispatch();

    // save handler once user update the data in edit pop modal 
    const saveHandler = () => {
        let negotiationIdAndStatusData = {
            id,
            contractStatus,
            isUpdated: true
        }
        if (isEditStatus === "Basic Details") {
            dispatch({
                type: UPDATE_DETAILED_NEGOTIATION_OVERVIEW,
                payload: {
                    basicDetailsData: formikRef.current?.values,
                    powerPositionDetails,
                    salesRepClassificationData,
                    TargetValueData,
                    isFormUpdate,
                    PlanNegotiationActions,
                    othersData,
                    isDetailedOverview: true,
                    negotiationIdAndStatusData
                },
            });
        } else if (isEditStatus === "Power Position") {
            dispatch({
                type: UPDATE_DETAILED_NEGOTIATION_OVERVIEW,
                payload: {
                    isFormUpdate,
                    basicDetailsData,
                    salesRepClassificationData,
                    TargetValueData,
                    PlanNegotiationActions,
                    othersData,
                    isDetailedOverview: true,
                    powerPositionDetails,
                    negotiationIdAndStatusData
                },
            });
        } else if (isEditStatus === "Target Value") {
            dispatch({
                type: UPDATE_DETAILED_NEGOTIATION_OVERVIEW,
                payload: {
                    isFormUpdate,
                    basicDetailsData,
                    salesRepClassificationData,
                    powerPositionDetails,
                    PlanNegotiationActions,
                    othersData,
                    TargetValueData: formikRef.current?.values,
                    isDetailedOverview: true,
                    negotiationIdAndStatusData
                },
            })
        } else {
            dispatch({
                type: UPDATE_DETAILED_NEGOTIATION_OVERVIEW,
                payload: {
                    isFormUpdate,
                    basicDetailsData,
                    salesRepClassificationData,
                    powerPositionDetails,
                    TargetValueData,
                    PlanNegotiationActions,
                    othersData,
                    isDetailedOverview: true,
                    negotiationIdAndStatusData
                },
            });
        }
        toggle()
    };

    // save button disable functionality for edit pop up modal 
    const saveBtnDisableHandler = () => {
        let isDisabled = true;
        if (["Basic Details", "TargetValue"].includes(isEditStatus)) {
            isDisabled = isNextDisabled
        } else if (isEditStatus === "Power Position") {
            isDisabled = !(powerPositionDetails?.powerPosition !== "" && powerPositionDetails?.powerPosition != null)
        } else if (isEditStatus === "Sales Rep Classification") {
            isDisabled = !(salesRepClassificationData?.classificationType !== "" && salesRepClassificationData.classificationType !== null)
        }else {
            isDisabled = false
        }

        return isDisabled;
    }
    return (
        <div>
            <Modal isOpen={isOpen} toggle={toggle} modalClassName="negotiation-edit-modal">
                <ModalHeader>
                    <div className="negotiation-header">{isEditStatus}</div>
                    <button type="button" className="btn-close" aria-label="Close " onClick={toggle} style={{ position: 'absolute', top: '24px', right: '24px', zIndex: 10, width: '4px', height: '4px' }}></button>
                </ModalHeader>
                <ModalBody>
                    <NegotiationFormComponent formName={isEditStatus} formikRef={formikRef} setIsNextDisabled={setIsNextDisabled} />
                </ModalBody>
                <ModalFooter>
                    <button className="stepper-button continue-button" disabled={saveBtnDisableHandler()} onClick={saveHandler}>Save</button>
            </ModalFooter>
        </Modal>
        </div >
    );
};

export default EditModalForNegotiation;
